import { useState } from 'react';
import { Button, Input, Select } from 'semantic-ui-react';
import { errorInput, searchSelectProps } from '../../components/helpers';
import styled from '@emotion/styled';
import Swal from 'sweetalert2/dist/sweetalert2';
import { screenSizes } from 'src/assets/styles/Literals';
import { TarjetahabienteInfo } from 'src/containers/events/reservation/components/tarjetahabienteInfo';

const DonationComp = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background-color: white;
  width: 90%;
  padding: 20px 50px;
  .back {
    width: 100%;
  }
  h1 {
    font-size: 40px;
    padding: 20px 0;
    width: 100%;
    text-align: center;
  }
  .donation-form {
    width: 80%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .info {
      width: 100%;
      margin: 0 0 20px 0;
      .subtitle {
        font-size: 22px;
        margin: 0;
      }
      .note {
        font-size: 12px;
      }
    }
    form {
      display: flex;
      flex-wrap: wrap;
      width: 80%;
      justify-content: center;
      div {
        width: 100%;
      }
      .ui.input {
        width: 100%;
        margin: 10px 0;
      }
    }
  }
  @media (max-width: ${screenSizes.tablet}) {
    width: 100%;
    .donation-form {
      width: 100%;
      form {
        width: 100%;
      }
    }
  }
`;

const DiezmosYOfrendas = (props) => {
  const [inputs, setInputs] = useState({
    type: 'Diezmo',
    currency: 'Pesos Colombianos',
  });
  const [errorInputs, set_errorInputs] = useState({});

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs({ ...inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const selectHandle = (a, { value, name }) => {
    setInputs({ ...inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const verifyForm = () => {
    let mandatoryInputs = [
      'nombre_completo',
      'identification',
      'type',
      'email',
      'currency',
      'value',
      'email',
      'es_tarjetahabiente',
    ];

    if (inputs.es_tarjetahabiente === 'No') {
      mandatoryInputs = [
        ...mandatoryInputs,
        'nombre_tarjetahabiente',
        'identificacion_tarjetahabiente',
      ];
    }

    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  const submit = (e) => {
    e.preventDefault();
    if (verifyForm()) return Swal.fire('Error', 'Por favor llene todos los campos', 'error');
    const { nombre_completo, type, identification, value, email } = inputs;
    const extra3 =
      inputs.es_tarjetahabiente === 'No' &&
      inputs.nombre_tarjetahabiente &&
      inputs.identificacion_tarjetahabiente
        ? `&extra3=${encodeURIComponent(
            `${inputs.nombre_tarjetahabiente}_${inputs.identificacion_tarjetahabiente}`
          )}`
        : '';

    props.history.push(
      `/payucheckout?amount=${value}&description=${type}&buyerEmail=${email}&buyerFullName=${nombre_completo}&identification=${identification}&extra1=${nombre_completo}${extra3}`
    );
  };

  return (
    <DonationComp>
      <div className="back">
        <Button secondary onClick={() => window.location.replace('https://comunidadmde.com/dar')}>
          Volver
        </Button>
      </div>
      <h1>Donaciones</h1>
      <div className="donation-form">
        <div className="info">
          <p className="subtitle">
            Cada campo del formulario debe ser respondido para pasar a la zona de donaciones
          </p>
          <p className="note">
            El certificado de donación se expedirá a nombre del tarjetahabiente
          </p>
        </div>
        <form>
          <div>
            <label htmlFor="nombre_completo" style={{ display: 'block' }}>
              Nombre completo:
            </label>
            <Input
              placeholder="Nombre completo"
              name={'nombre_completo'}
              value={inputs.nombre_completo}
              style={{ padding: 0 }}
              onChange={handleInputs}
              className={`Registration__input Registration__input-${'nombre_completo'} ${
                errorInputs['nombre_completo'] ? 'error' : ''
              }`}
            />
          </div>
          <div>
            <label htmlFor="identification" style={{ display: 'block' }}>
              Número de identificación:
            </label>
            <Input
              placeholder="Número de identificación"
              name={'identification'}
              type="number"
              value={inputs.identification}
              style={{ padding: 0 }}
              onChange={handleInputs}
              className={`Registration__input Registration__input-${'identification'} ${
                errorInputs['identification'] ? 'error' : ''
              }`}
            />
          </div>
          <div>
            <label htmlFor="email" style={{ display: 'block' }}>
              Email:
            </label>
            <Input
              placeholder="Email"
              type="email"
              name={'email'}
              value={inputs.email}
              style={{ padding: 0 }}
              onChange={handleInputs}
              className={`Registration__input Registration__input-${'email'} ${
                errorInputs['email'] ? 'error' : ''
              }`}
            />
          </div>
          <div>
            <label htmlFor="type" style={{ display: 'block' }}>
              Concepto:
            </label>
            <Select
              placeholder="Concepto"
              className={`Registration__input Registration__input-${'type'} ${
                errorInputs['type'] ? 'error' : ''
              }`}
              {...searchSelectProps({
                name: 'type',
                value: inputs.type,
                handler: selectHandle,
                options: [
                  'Diezmo',
                  'Ofrenda',
                  'Protemplo',
                  'España',
                  'Fundacion Viento Fresco',
                  'Misiones',
                  'Otros',
                ].map((a) => {
                  return { key: a, value: a, text: a };
                }),
              })}
            />
          </div>
          {/* <div>
            <label htmlFor="currency" style={{ display: 'block' }}>
              Moneda:
            </label>
            <Select search
              placeholder="Moneda"
              value={inputs.currency}
              onChange={selectHandle}
              name="currency"
              className={`Registration__input Registration__input-${'currency'} ${
                errorInputs['currency'] ? 'error' : ''
              }`}
              options={[
                'Pesos Colombianos',
                'Dólar Americano',
                'Peso Mexicano',
                'Nuevo Sol Perua',
                'Real Brasileño',
                'Peso Argentino',
              ].map((a) => {
                return { key: a, value: a, text: a };
              })}
            />
          </div> */}
          <div>
            <label htmlFor="value" style={{ display: 'block' }}>
              Valor a donar en {inputs.currency}:
            </label>
            <Input
              placeholder="Valor a donar"
              name={'value'}
              type="number"
              value={inputs.value}
              style={{ padding: 0 }}
              onChange={handleInputs}
              className={`Registration__input Registration__input-${'value'} ${
                errorInputs['value'] ? 'error' : ''
              }`}
            />
          </div>
          <TarjetahabienteInfo
            inputs={inputs}
            errorInputs={errorInputs}
            handleInputs={handleInputs}
            selectHandle={selectHandle}
            question="¿El titular de la donación es el mismo tarjetahabiente o titular de la cuenta bancaria?"
          />
          <div>
            <Button onClick={submit} primary>
              Ir a Donar
            </Button>
          </div>
        </form>
      </div>
    </DonationComp>
  );
};
export default DiezmosYOfrendas;
